import React from 'react'
import logUtil from 'utils/log'
import useSelector from 'hooks/use-selector'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import SquadPageCurrentFriendHasNotTriedSamplesYetContent from 'pages/Squad/containers/Friends/CurrentFriendHasNotTriedSamplesYet/Content'
import getCurrentMemberIdSquadSelect from 'modules/squad/redux/selectors/get-current-member-id'
import getSurveyStatsByMemberIdSquadSelector from 'modules/squad/redux/selectors/get-survey-stats-by-member-id'

const ANALYTICS_EVENT = {
  SQUAD_SHOW_CURRENT_FRIEND_HAS_NOT_TRIED_SAMPLES_YET: 'SQUAD_SHOW_CURRENT_FRIEND_HAS_NOT_TRIED_SAMPLES_YET'
}

export default function SquadPageCurrentFriendHasNotTriedSamplesYet () {
  const currentMemberId = useSelector(getCurrentMemberIdSquadSelect)

  /**
   * @type {import('modules/squad/types').SurveyStats}
   */
  const surveyStats = useSelector(getSurveyStatsByMemberIdSquadSelector(currentMemberId))
  const debugProps = {
    currentMemberId,
    surveyStats
  }
  logUtil('SquadPageCurrentFriendHasNotTriedSamplesYet').debug('debugProps=', debugProps)

  React.useEffect(() => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_SHOW_CURRENT_FRIEND_HAS_NOT_TRIED_SAMPLES_YET)
  }, [])

  if (!surveyStats || surveyStats?.survey_answer_count) {
    return <></>
  }

  return (
    <SquadPageCurrentFriendHasNotTriedSamplesYetContent
      surveyStats={surveyStats}
    />
  )
}
